import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Input, Select } from '../../../../components/ModalInputs'
import { getTeacherByGroupId, addGroupUser } from '../../../../actions/permissions'
import CustomSelect from '../../../../components/CustomSelect'
import { OrderContext } from '../../../../utils/context'
import { arrayForSelect } from '../../../../utils/arrayForSelect'
import moment from 'moment'
import { getCourses } from '../../../../actions/common'

const ARR = [
  { id: 1, name: '2' },
  { id: 2, name: '3' },
  { id: 3, name: '4' },
  { id: 4, name: '5' },
  { id: 5, name: '6' },
  { id: 6, name: '7' },
  { id: 7, name: '8' },
  { id: 8, name: '9' },
  { id: 9, name: '10' },
  { id: 10, name: '11' },
  { id: 11, name: '12' },

]

export default function GrantingLeave() {

  const dispatch = useDispatch()

  const { values, personnelList, setFieldValue, handleChange, specFields, error } = useContext(OrderContext)

  const { courses } = useSelector(state => state.common)

  const renderSelect = specFields && specFields.find(item => item.displaylabel.slice(0, 11) === 'Вид отпуска');


  useEffect(() => {
    dispatch(getCourses())
  }, [])

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='ФИО'
              valuesName="mid"
              options={arrayForSelect(personnelList, 'fio', 'mid')}
              // value={personnelList && personnelList?.find(item => item.mid == values.mid)?.fio}
              value={values.mid}
              setFieldValue={setFieldValue}
              withoutAll
              width={300}
              error={error('mid')}
            />
          </div>
          <div className={styles.inputsRow}>
            <Select
              label='Вид отпуска'
              name='string2'
              value={values.string2}
              error={error('string2')}
              onChange={handleChange}
            >
              <option value=''>Не выбран</option>
              {renderSelect?.param_data?.map(item => <option value={item.idorderspecdicts}>{item.value}</option>)}
            </Select>
          </div>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='Дата с'
              name='date'
              value={moment(values.date).format('YYYY-MM-DD')}
              onChange={handleChange}
              error={error('date')}
            />
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='по'
              name='date2'
              value={moment(values.date2).format('YYYY-MM-DD')}
              onChange={handleChange}
              error={error('date2')}
            />

          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Единовременное пособие по постановке на учет в ранние сроки беременности'
              name='money'
              type='number'
              // value={values.money} 
              value={`${values.money} руб.`}
              error={error('money')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Основание'
              name='string'
              value={values.string}
              error={error('string')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Примечание'
              name='string'
              value={values.string}
              error={error('string')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
        </div>
      </div >

    </>
  )
}
